import type { ElementType, JSX } from 'react'

import { Box, Icon, Tooltip, TooltipProps } from '@chakra-ui/react'
import { wwtMemo } from '@wwt/custom/wwt'

import { TooltipIconType } from '../types/TooltipIconType.ts'
import { tooltipIconColorMap } from '../utils/TooltipIconColorConfig.ts'

interface TooltipBaseContentProps extends TooltipProps {
	children: JSX.Element
	tooltipIconType?: TooltipIconType
	TooltipIcon: ElementType
}

/**
 * Component for show base tooltip content
 *
 * @author Ivan Shchedrovskyi
 */
export const TooltipBaseContent = wwtMemo(
	({
		children,
		tooltipIconType,
		TooltipIcon,
		...props
	}: TooltipBaseContentProps) => {
		const textColorVar =
			tooltipIconColorMap[tooltipIconType ?? TooltipIconType.DEFAULT]
		return (
			<Tooltip
				label={children}
				maxW="20rem"
				maxH="29.375rem"
				openDelay={200}
				{...props}
			>
				<Box width="1rem">
					<Icon
						as={TooltipIcon}
						width="1rem"
						height="1rem"
						style={{ color: `var(${textColorVar})` }}
					/>
				</Box>
			</Tooltip>
		)
	}
)
